import React from 'react';

interface RiskCardProps {
  riskCount: number;
  delayedCount: number;
  unallocatedCount: number;
  blockedCount?: number;
}

const RiskCard: React.FC<RiskCardProps> = ({ riskCount, delayedCount, unallocatedCount, blockedCount = 0 }) => {
  if (riskCount === 0) {
    return null;
  }

  return (
    <div className="relative flex flex-col items-center p-2 bg-gradient-to-br from-red-50 to-rose-50 dark:from-red-900/20 dark:to-rose-900/20 rounded-lg border-2 border-red-500 dark:border-red-600 w-full hover:shadow-lg transition-shadow group">
      <svg className="absolute -top-1.5 -right-1.5 w-5 h-5 text-red-600 dark:text-red-400" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      </svg>
      <div className="text-2xl font-bold text-red-600 dark:text-red-400">{riskCount}</div>
      <div className="text-[8px] text-red-700 dark:text-red-300 uppercase tracking-wide">At Risk</div>

      {/* Hover Tooltip with Breakdown - positioned on LEFT */}
      <div className="absolute right-full mr-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap">
        <div className="bg-gray-900 dark:bg-slate-800 text-white text-xs rounded-lg py-2 px-3 shadow-lg border border-gray-700">
          <div className="font-bold mb-1.5 border-b border-gray-700 pb-1">Risk Breakdown</div>
          {delayedCount > 0 && (
            <div className="flex justify-between gap-3 items-center mb-1">
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-orange-500"></div>
                <span className="text-gray-300">Delayed:</span>
              </div>
              <span className="font-semibold">{delayedCount}</span>
            </div>
          )}
          {blockedCount > 0 && (
            <div className="flex justify-between gap-3 items-center mb-1">
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#991b1b' }}></div>
                <span className="text-gray-300">Blocked:</span>
              </div>
              <span className="font-semibold">{blockedCount}</span>
            </div>
          )}
          {unallocatedCount > 0 && (
            <div className="flex justify-between gap-3 items-center">
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-amber-500"></div>
                <span className="text-gray-300">Unallocated:</span>
              </div>
              <span className="font-semibold">{unallocatedCount}</span>
            </div>
          )}
          {/* Arrow pointing right to the card */}
          <div className="absolute left-full top-1/2 -translate-y-1/2 ml-px">
            <div className="border-4 border-transparent border-l-gray-900 dark:border-l-slate-800"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskCard;